import { render, staticRenderFns } from "./SubsidyItemInfoForm.vue?vue&type=template&id=c0f2248a&"
import script from "./SubsidyItemInfoForm.vue?vue&type=script&lang=js&"
export * from "./SubsidyItemInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports